var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18IcSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625,10.5 L11.0325,10.5 L10.8225,10.2975 C11.5575,9.4425 12,8.3325 12,7.125 C12,4.4325 9.8175,2.25 7.125,2.25 C4.4325,2.25 2.25,4.4325 2.25,7.125 C2.25,9.8175 4.4325,12 7.125,12 C8.3325,12 9.4425,11.5575 10.2975,10.8225 L10.5,11.0325 L10.5,11.625 L14.25,15.3675 L15.3675,14.25 L11.625,10.5 L11.625,10.5 Z M7.125,10.5 C5.2575,10.5 3.75,8.9925 3.75,7.125 C3.75,5.2575 5.2575,3.75 7.125,3.75 C8.9925,3.75 10.5,5.2575 10.5,7.125 C10.5,8.9925 8.9925,10.5 7.125,10.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18IcSearch);
export default __webpack_public_path__ + "static/media/18_ic_search.784b378b.svg";
export { ForwardRef as ReactComponent };